<template>
  <v-container fluid fill-height style="background-color: #ddd">
    <v-row align="center" justify="center">
      <v-col col="12" md="8">
        <v-card class="elevation-10 pa-5 pa-md-10 rounded-xl">
          <v-card-text>
            <iusa-logo lg />

            <h6 class="my-5">
              <v-icon color="black"> mdi-lock </v-icon>
              <strong>Su correo electrónico ha sido validado</strong>
            </h6>

            <div>
              <p class="mt-5">
                Su correo electrónico fue validado correctamente. Pronto
                recibirá más instrucciones.
              </p>

              <help-banner class="mt-7">
                <span>
                  Si tiene alguna duda puede ponerse en contacto con el
                  <strong class="red--text">Soporte IUSA en línea</strong>
                  en los siguientes canales:
                </span>
              </help-banner>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import IusaLogo from '@/components/IusaLogo';
  import HelpBanner from '@/components/HelpBanner';

  export default {
    name: 'EmailValidated',

    components: {
      IusaLogo,
      HelpBanner,
    },
  };
</script>
